import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { BatchLimitationViewControllerDelegate, BatchLimitationViewController } from "../../Screen/BatchLimitation/BatchLimitationViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { BatchLimitationViewModel } from '../../Screen/BatchLimitation/BatchLimitationViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class BatchLimitationCoordinator implements IndexCoordinatorDelegate, BatchLimitationViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geplimitacaolote")
        return (<ProtectedRoute path="/:base/limitacao-lote" exact={true} component={(props: any) => {
            return (<TableGenericViewController 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Limitação Lote"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new BatchLimitationViewModel()
        return (<ProtectedRoute path="/:base/limitacao-lote/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<BatchLimitationViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geplimitacaolote") {
            navigation.history.push(`limitacao-lote/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geplimitacaolote") {
            navigation.history.push(`limitacao-lote/cad/${idSelection}`);
            return;
        }
    }

}